import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

export default defineType({
  title: 'Feature',
  name: 'feature',
  type: 'object',
  fields: [
    defineField({
      title: 'Photo',
      name: 'photo',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Title',
      name: 'name',
      type: 'string',
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      title: 'Description',
      name: 'description',
      type: 'array',
      of: strongEmLink,
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      title: 'Sub Module',
      name: 'subModule',
      type: 'string',
      options: {
        list: [
          { title: 'None', value: '' },
          { title: 'Load Rating', value: 'loadRating' },
          { title: 'Graphs', value: 'graphs' },
          { title: 'Reinforcement', value: 'reinforcement' },
          { title: '32mm Socket', value: 'socket' },
        ],
      },
      initialValue: '',
    }),
    defineField({
      title: 'Load Rating',
      name: 'loadRating',
      type: 'loadRating',
      hidden: ({ parent }: { parent?: any }) => parent?.subModule !== 'loadRating',
    }),
    defineField({
      title: 'Graphs',
      name: 'graphs',
      type: 'graphs',
      hidden: ({ parent }: { parent?: any }) => parent?.subModule !== 'graphs',
    }),
    defineField({
      title: 'Reinforcement',
      name: 'reinforcement',
      type: 'object',
      fields: [
        defineField({
          title: 'Percentage',
          name: 'percentage',
          type: 'number',
          validation: (Rule) => Rule.integer().positive().min(1).max(100),
        }),
        defineField({
          title: 'Info',
          name: 'info',
          type: 'array',
          of: strongEmLink,
          validation: (Rule) => Rule.required(),
        }),
      ],
      hidden: ({ parent }: { parent?: any }) => parent?.subModule !== 'reinforcement',
    }),
    defineField({
      title: 'Button',
      type: 'link',
      name: 'button',
    }),
  ],
})